// Brand contact constants (public — shown to customers)
export const PAYMENT_EMAIL = "washeduptrainers@gmail.com";
export const BRAND_NAME = "Washed Up Trainers";
export const SITE_NAME = "The Washed Up Arena";
export const TIKTOK_HANDLE = "washeduptrainerss";
export const TIKTOK_URL = "https://www.tiktok.com/@washeduptrainerss";
export const INSTAGRAM_HANDLE = "washeduptrainers";
export const INSTAGRAM_URL = "https://www.instagram.com/washeduptrainers/";
export const FACEBOOK_HANDLE = "Washed Up Trainers";
export const FACEBOOK_URL = "https://www.facebook.com/p/Washed-Up-Trainers-61591734924491/";
